import React from 'react';
import Calendar from '../../assets/Calendar.png';

/**
 * EmptyState displays a centred illustration with a heading, a sub-paragraph,
 * and an optional call-to-action button. Used whenever a list or timeline has
 * no items to show (e.g. "no sessions scheduled for this day").
 */

type EmptyStateProps = {
  /** Primary heading shown below the illustration. */
  title: string;
  /** Supporting paragraph text. */
  description: string;
  /** Label for the optional action button. */
  actionLabel?: string;
  /** Called when the action button is clicked. Only rendered when provided together with actionLabel. */
  onAction?: () => void;
  /** If false the action button is hidden even when onAction is supplied (e.g. for past days). */
  showAction?: boolean;
  /** Optional id attribute forwarded to the action button for tour targeting. */
  actionButtonId?: string;
  /** If true, removes the card border and background (e.g. when already inside a bordered container). */
  noBorder?: boolean;
};

export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  actionLabel,
  onAction,
  showAction = true,
  actionButtonId,
  noBorder = false,
}) => {
  return (
    <div className="sess-empty-only">
      <style>{`
        .sess-empty-only { display:flex; justify-content:center; }
        .empty { border:1px solid #e5e7eb; border-radius:14px; background:#fff; padding:18px; text-align:center; }
        .empty.no-border { border:none; background:transparent; }
        .empty h4 { margin:0 0 6px 0; color:#111827; font-size:1rem; }
        .empty p { margin:0 0 12px 0; color:#6b7280; }
        .empty-illustration { width: 200px; height: auto; display:block; margin: 6px auto 10px auto; }
      `}</style>
      <div className={`empty${noBorder ? " no-border" : ""}`}>
        <img src={Calendar} alt="" className="empty-illustration" />
        <h4>{title}</h4>
        <p>{description}</p>
        {showAction && actionLabel && onAction && (
          <button
            type="button"
            className="btn-primary"
            onClick={onAction}
            style={{ marginTop: 8 }}
            id={actionButtonId}
            data-tour="schedule-button"
          >
            {actionLabel}
          </button>
        )}
      </div>
    </div>
  );
};

export default EmptyState;
